export default async (ctx, inject) => {
  const options = {"el":{"icons":true,"email":"info@statica.eu","phone":"+30 210 9219 575"},"en":{"icons":true,"email":"info@statica.eu","phone":"+30 210 9219 575"}}
  const attrs = Object.values(options)[0]

  const contact = {
    ...options,
    get details() {
      return this[ctx.app.i18n.vm.locale] || {}
    }
  }

  Object.keys(attrs).forEach(key => {
    Object.defineProperty(contact, key, {
      get() {
        return this.details[key]
      }
    })
  })

  inject('contact', contact)
}
